import { Button } from "@sellar-io/components";
import { useForm } from "react-hook-form";
import { InputContainer } from "@sellar-io/components";
import { InputText } from "@sellar-io/components";

type CheckoutEditPurchaseOrderFormProps = {
  initialData: string;
  onConfirm: (data: string) => void;
};

type PurchaseOrder = { purchaseOrderNumber: string };

export const CheckoutEditPurchaseOrderForm = ({
  initialData,
  onConfirm,
}: CheckoutEditPurchaseOrderFormProps) => {
  const { register, handleSubmit } = useForm<PurchaseOrder>({
    defaultValues: { purchaseOrderNumber: initialData },
    shouldUseNativeValidation: true,
  });

  const handleUserSubmit = (data: PurchaseOrder) => {
    onConfirm(data.purchaseOrderNumber);
  };

  return (
    <form
      className="flex flex-col gap-2"
      onSubmit={handleSubmit(handleUserSubmit)}
    >
      <InputContainer>
        <InputText
          {...register("purchaseOrderNumber", { required: true })}
          placeholder="PO123456"
        />
      </InputContainer>

      <Button type="submit" className="w-full">
        Update
      </Button>
    </form>
  );
};
